<!-- Delivery Plan Viewer: left panel (desktop, dispatcher mode) + map with its overlays. -->
<div class="delivery-plan-viewer">
    <div class="delivery-plan-viewer__body">
        <app-delivery-plan-viewer-left-panel
            *ngIf="!isCourierMode && !isMobile"
            [orders]="visibleOrders"
            [unassigned]="unassignedOrders"
            [showUnassignedOnMap]="showUnassignedOnMap"
            [canToggleUnassignedOnMap]="canToggleUnassignedOnMap"
            [deliveryDate]="deliveryDate"
            [isLoadingPlan]="isLoadingPlan"
            [selectedOrderCode]="selectedOrderCode"
            (changeDate)="changeDate($event)"
            (pickDate)="setDeliveryDate($event)"
            (deleteOrder)="deleteOrder($event)"
            (selectOrder)="onOrderSelected($event)"
            (selectUnassignedOrder)="onUnassignedOrderSelected($event)"
            (toggleUnassignedOnMap)="toggleUnassignedOnMap()"
        ></app-delivery-plan-viewer-left-panel>

        <div class="delivery-plan-viewer__map-wrap">
            <!-- The Leaflet map (tiles, route lines, stop markers) is created in this element. -->
            <div #mapContainer class="delivery-plan-viewer__map"></div>

            <div *ngIf="hasNoPlan && !isCourierMode" class="delivery-plan-viewer__no-plan" role="status">
                {{ 'delivery-plan-viewer.no-published-plan' | translate: { date: formatDate(deliveryDate) } }}
            </div>
            <div *ngIf="showCourierNoRoute" class="delivery-plan-viewer__no-plan" role="status">
                {{ 'delivery-plan-viewer.no-route-today' | translate }}
            </div>

            <app-delivery-plan-viewer-courier-legend
                *ngIf="legendItems.length > 0 && !isCourierMode"
                class="delivery-plan-viewer__legend"
                [items]="legendItems"
                [filteredCourierId]="filteredCourierId"
                (filterChanged)="setCourierFilter($event)"
            ></app-delivery-plan-viewer-courier-legend>

            <!--
                Stops panel of the filtered courier: stops per shift, PNG download.
                Shown only while a courier in the plan is filtered (always in courier mode).
                Desktop: floats top right. Mobile: draggable bottom sheet over the full width.
            -->
            <app-delivery-plan-viewer-stops-panel
                *ngIf="filteredRouteIndex >= 0"
                class="delivery-plan-viewer__stops-panel"
                [class.delivery-plan-viewer__stops-panel--sheet]="isMobile"
                [asBottomSheet]="isMobile"
                [shifts]="routes[filteredRouteIndex].shifts"
                [color]="courierColor(filteredRouteIndex)"
                [courierLabel]="courierLabel(filteredCourierId)"
                [selectedStopId]="selectedStopId"
                (selectStop)="onStopSelected($event)"
            ></app-delivery-plan-viewer-stops-panel>

            <lib-inline-toast></lib-inline-toast>

            <div
                class="delivery-plan-viewer__zoom"
                [class.delivery-plan-viewer__zoom--above-sheet]="isMobile && filteredRouteIndex >= 0"
            >
                <button
                    *ngIf="isMobile && canToggleUnassignedOnMap"
                    type="button"
                    class="delivery-plan-viewer__unassigned-toggle"
                    [class.is-active]="showUnassignedOnMap"
                    [attr.aria-pressed]="showUnassignedOnMap"
                    [title]="'delivery-plan-viewer.show-unassigned-on-map' | translate"
                    (click)="toggleUnassignedOnMap()"
                >
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    <span class="delivery-plan-viewer__unassigned-count">{{ unassignedWithLocationCount }}</span>
                </button>
                <button type="button" [title]="'common.zoom-in' | translate" (click)="zoomIn()">+</button>
                <button type="button" [title]="'common.zoom-out' | translate" (click)="zoomOut()">&minus;</button>
            </div>
        </div>
    </div>
</div>

<ng-template #orderDetailsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="order-details-modal-title">
            {{ 'delivery-plan-viewer.order-details-title' | translate: { code: detailsOrderCode } }}
        </h5>
        <button
            type="button"
            class="close"
            aria-label="Close button"
            aria-describedby="order-details-modal-title"
            (click)="modal.dismiss('Cross click')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body order-details">
        <div *ngFor="let row of detailsRows" class="order-details__row">
            <span class="order-details__label">{{ row.label | translate }}:</span>
            <span class="order-details__value">{{
                row.translateValue ? (row.value | translate) : row.value
            }}</span>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="order-details__close" (click)="modal.close()">
            {{ 'common.close' | translate }}
        </button>
    </div>
</ng-template>